import { render, staticRenderFns } from "./dropdown_page.vue?vue&type=template&id=eccff7d0"
import script from "./dropdown_page.vue?vue&type=script&lang=js"
export * from "./dropdown_page.vue?vue&type=script&lang=js"
import style0 from "./dropdown_page.vue?vue&type=style&index=0&id=eccff7d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports